import { ITicker } from '@kattana-io/common';
import BigNumber from 'bignumber.js';
import { GWEI } from '../reducers/dex/limitReducer';

export const getPriceForPair = ({
  ticker,
  quotePrice,
  rate,
}: {
  quotePrice?: boolean;
  ticker?: ITicker;
  rate?: BigNumber;
}) => {
  if (rate && rate.isGreaterThan(0)) {
    return BigNumber(1).div(rate).toNumber();
  }
  if (ticker) {
    if (quotePrice) {
      const price = ticker.flipped ? ticker.price_b : ticker.price_a;
      return price;
    } else {
      const price = ticker.flipped ? ticker.price_a : ticker.price_b;
      return price;
    }
  }
  return 0;
};

export const getPriceUSDForPair = (ticker?: ITicker, address?: string) => {
  if (ticker && address) {
    const price =
      ticker.base_address.toLowerCase() === address.toLowerCase()
        ? ticker.price_a_usd
        : ticker.price_b_usd;
    return price;
  }
  return 0;
};

export const getPriceImpact = (amount: BigNumber, min: number): number => {
  try {
    if (min) {
      const diff = BigNumber(amount).minus(min);
      const impact = diff.div(min).multipliedBy(100);
      return impact.toNumber();
    }
    return 0;
  } catch (e) {
    console.warn('getPriceImpact:', e);
    return 0;
  }
};

export const getGasCost = (gasPrice: BigNumber, gasUnits?: string): string => {
  try {
    if (gasUnits) {
      const gas = BigNumber(gasUnits)
        .multipliedBy(gasPrice)
        .div(10 ** 18)
        .toPrecision(2);
      return gas;
    }
    return '0.0';
  } catch (e) {
    console.warn('getGasCost:', e);
    return '0.0';
  }
};

export const getGasCostUSD = (gasCostUSD?: string): string => {
  const gas = Number(gasCostUSD);

  if (gas) {
    return `$${gas.toFixed(4)}`;
  }
  return '$0.0';
};

export const getLimitFee = (tradesCount: number) =>
  500_000 * 5 * GWEI * tradesCount;

export const getLimitExecutionPrice = (amount: number, slippage: number) => {
  const afterSlippage = (100 - slippage) / 100;

  return amount * afterSlippage;
};
